import type { IPascoRepository, SearchPascoResult } from "@src/domain/pascos/repository/pasco_repository";
import type { PascoListItemDTO } from "../dto";
import { PascoDtoMapper } from "../mappers/pasco-dto.mapper";

/**
 * Use Case: Search Public PASCOs
 * Searches public PASCOs by course name or course code with optional filters
 */
export class SearchPublicPascosUseCase {
    constructor(private readonly pascoRepository: IPascoRepository) { }

    async execute(
        query: string,
        universityId?: string,
        semester?: string,
        academicYear?: string,
        skip?: number,
        limit?: number
    ): Promise<{ pascos: PascoListItemDTO[]; total: number; hasMore: boolean }> {
        const result: SearchPascoResult = await this.pascoRepository.searchPublicPascos({
            q: query,
            university_id: universityId,
            semester,
            academic_year: academicYear,
            skip,
            limit,
        });

        return {
            pascos: PascoDtoMapper.toListItemDTOArray(result.pascos),
            total: result.total,
            hasMore: result.hasMore,
        };
    }
}
